import React, { useMemo, useState, useEffect } from "react";
import "./completenessPopup.css";
import useAgentProfile from "../../../pages/AgentProfile/use-AgentProfile";
import { useNavigate } from "react-router-dom";

const CompletenessPopup = ({ isFirstLogin }) => {
  const { formData } = useAgentProfile();
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  // Calculate completeness
  const completeness = useMemo(() => {
    const editableFields = ["callName", "whatsappNo", "email", "facebook"];
    const completedFields = editableFields.filter(
      (field) => formData[field] && formData[field].toString().trim() !== ""
    ).length;
    const photoCompleted = formData?.profilePhoto === true ? 1 : 0;
    const total = editableFields.length + 1;
    return Math.round(((completedFields + photoCompleted) / total) * 100);
  }, [formData]);

  // Show popup only on first login and if not dismissed in session
  useEffect(() => {
    if (isFirstLogin) {
      const dismissed = sessionStorage.getItem('completenessPopupDismissed');
      if (!dismissed && completeness < 100) {
        setVisible(true);
      }
    }
  }, [isFirstLogin, completeness]);

  const handlePrimaryAction = () => {
    setVisible(false);
    sessionStorage.setItem('completenessPopupDismissed', 'true');
    navigate("/eProfile");
  };

  const handleSecondaryAction = () => {
    setVisible(false);
    sessionStorage.setItem('completenessPopupDismissed', 'true');
  };

  if (!visible) return null;

  // Popup content
  let title = "Complete your profile";
  let message = "Please enter your information to activate your personalized Business Card.";
  let primaryLabel = "Edit Profile";
  let showSecondary = true;
  let secondaryLabel = "Remind me later";

  if (formData?.profilePhoto === false) {
    message = "Please upload a profile photo to help others recognize you and to activate your Business Card.";
    primaryLabel = "Upload Photo";
  } else if (completeness < 100) {
    title = "Complete your eprofile";
    message = "Complete your Profile to update your Business Card.";
    primaryLabel = "Edit Profile";
  } else {
    // Already complete
    return null;
  }

  return (
    <div className="profile-status-popup">
      {/* Title */}
      <div className="popup-title">{title}</div>

      {/* Percentage + message */}
      <div className="popup-message">
        <strong>{completeness}% complete</strong> — {message}
      </div>

      {/* Action buttons */}
      <div className="popup-actions">
        <button className="popup-primary" onClick={handlePrimaryAction}>
          {primaryLabel}
        </button>
        {showSecondary && (
          <button className="popup-secondary" onClick={handleSecondaryAction}>
            {secondaryLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default CompletenessPopup;
